import { render } from "./GroupTree.vue?vue&type=template&id=6f57f16b&scoped=true"
import script from "./GroupTree.vue?vue&type=script&lang=js"
export * from "./GroupTree.vue?vue&type=script&lang=js"

import "./GroupTree.vue?vue&type=style&index=0&id=6f57f16b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f57f16b"]])

export default __exports__